/* eslint-disable */
import React, { useState, useEffect } from "react";
import {
  doc,
  collection,
  query,
  where,
  getDocs,
  getDoc,
  updateDoc,
  arrayUnion
} from "firebase/firestore";
import { db } from "../../../../firebase";
import { useDispatch } from "react-redux";
import { updateProduct } from "../../../../redux/products/products";
import { fetchAccount } from "../../../../redux/account/account";
import workerAPI from "../../../../api/worker/worker_service";

import usePagination from "../../../helper/paginate/Pagination";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import Swal from "sweetalert2";
import "../../../../pages/dashboard/yoda.css";
import "./DataTableDemo.css";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Switch, Col, Row, Modal, Checkbox } from "antd";
import axios from "axios";
import {
  Tag,
  Eye,
  Edit,
  Trash,
  MoreVertical,
  ChevronDown,
  ChevronUp,
} from "lucide-react";
import useIsDark from "../../../../utils/isDark";
const DataTableTemplatingDemo = ({
  setLgShow,
  setData,
  filter,
  pageSize,
  filteredProducts,
}) => {
  // Get products from Redux or filteredProducts prop
  const dispatch = useDispatch();
  const products =
    filteredProducts ||
    useSelector((state) => {
      const allProducts = state.ProductsReducer || [];

      if (filter) {
        const searchTerm = filter.toLowerCase();
        return allProducts.filter(
          (product) =>
            (product.name && product.name.toLowerCase().includes(searchTerm)) ||
            (product.sku && product.sku.toLowerCase().includes(searchTerm))
        );
      }
      // Return all products if no filter is applied
      return allProducts;
    });

  const account = useSelector((state) => state.AccountReducer);
  console.log("account in DataTableTemplatingDemo:", account);
  const worker = useSelector((state) => state.workerReducer);
  const permissions = worker?.permissions || {};
  const canViewOrders = permissions["orders.view"] === true;
  const canViewProducts = permissions["products.view"] === true;
  const canViewStore = permissions["store.view"] === true;
  const canEditProducts = permissions["products.update"] === true;
  const canDeleteProducts = permissions["products.delete"] === true;
  const canEditStore = permissions["store.update"] === true;
  const CanAddProduct = permissions["products.create"] === true;
  const store = useSelector((state) => state.StoreReducer);
  const [confirmers, setConfirmers] = useState([]);
  const [page, setPage] = useState(1);
  const PER_PAGE = pageSize;
  const [expandedRows, setExpandedRows] = useState({});
  const count = Math.ceil(products.length / PER_PAGE);
  const _DATA = usePagination(products, PER_PAGE);
  const [isAll, setIsAll] = useState(false);
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [verificationCode, setVerificationCode] = useState("");
  const [pendingRowData, setPendingRowData] = useState(null);
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;
  const direction = currentLang === "ar" ? "rtl" : "ltr";
  const isDark = useIsDark();
  const currencyMap = {
    دج: {
      ar: "دج",
      fr: "DA",
      en: "DZD",
    },
  };
  const localizedCurrency =
    currencyMap[store.currencySymbol]?.[i18n.language] || store.currencySymbol;

  // Add state to track which dropdown is open
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const darkModeStyles = `
  /* Mode sombre spécifique au tableau personnalisé */
  .dark table thead tr th {
    background-color: #1e1e1e !important;
    color: #d1d5db !important;
    border-color: #3c3a3d !important;
    border-top: 1px solid #3c3a3d !important;
    border-bottom: 1px solid #3c3a3d !important;
  }

  .dark table tbody tr {
    background-color: #181919 !important;
    color: #d1d5db !important;
    border-color: #3c3a3d !important;
  }

  .dark table tbody tr:nth-child(even) {
    background-color: #1e1e1e !important;
  }

  .dark table tbody tr:nth-child(odd) {
    background-color: #181919 !important;
  }

  .dark table tbody tr td {
    border-color: #3c3a3d !important;
    color: #d1d5db !important;
  }
`;

  useEffect(() => {
    const styleTag = document.createElement("style");
    styleTag.innerHTML = darkModeStyles;
    document.head.appendChild(styleTag);
    return () => {
      document.head.removeChild(styleTag);
    };
  }, []);

  const handleChange = (e, p) => {
    setPage(p);
    _DATA.jump(p);
  };

  // Toggle row expansion
  const toggleRow = (productId) => {
    setExpandedRows((prev) => ({
      ...prev,
      [productId]: !prev[productId],
    }));
  };

  useEffect(() => {
    const fetchConfirmersAndInvitations = async () => {
      if (account && account?.user) {
        try {
        const confirmersQuery = query(
          collection(db, "confirmers"),
          where("addedBy", "==", account?.user)
        );
        const invitationsQuery = query(
          collection(db, "invitations"),
          where("status", "==", 2),
          where("shopUser", "==", account?.user)
        );

        const [confirmersSnapshot, invitationsSnapshot] = await Promise.all([
          getDocs(confirmersQuery),
          getDocs(invitationsQuery),
        ]);

        const confirmersList = confirmersSnapshot.docs.map((item) => ({
          ...item.data(),
          id: item.id,
        }));

        const confirmUserIds = [
          ...new Set(
            invitationsSnapshot.docs
              .map((item) => item.data()?.confirmUser)
              .filter(Boolean)
          ),
        ];

        let invitationConfirmers = [];
        if (confirmUserIds.length > 0) {
          const userIdBatches = [];
          for (let index = 0; index < confirmUserIds.length; index += 10) {
            userIdBatches.push(confirmUserIds.slice(index, index + 10));
          }

          const invitationSnapshots = await Promise.all(
            userIdBatches.map((batch) =>
              getDocs(
                query(collection(db, "confirmers"), where("user", "in", batch))
              )
            )
          );

          invitationConfirmers = invitationSnapshots.flatMap((snapshot) =>
            snapshot.docs.map((item) => ({
              ...item.data(),
              id: item.id,
            }))
          );
        }

        const merged = new Map();
        [...confirmersList, ...invitationConfirmers].forEach((item) => {
          merged.set(item.id || item.user, item);
        });

        setConfirmers(Array.from(merged.values()));
        } catch (error) {
          console.error("Error fetching confirmers/invitations:", error);
        }
      }
    };

    fetchConfirmersAndInvitations();
  }, [account?.user]);

  const syncAccountIfProvided = (responsePayload) => {
    const nextAccount = responsePayload?.account;
    if (nextAccount && nextAccount.id) {
      dispatch(fetchAccount(nextAccount));
    }
  };

  const changepaid = async (data, status) => {
    const updatedProduct = await workerAPI.updateProduct(data.id, {
      show: status,
    });

    syncAccountIfProvided(updatedProduct);
    dispatch(updateProduct(updatedProduct));
  };

  const message = () => {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success mx-2",
        cancelButton: "btn btn-danger mx-2",
      },
      buttonsStyling: false,
    });

    swalWithBootstrapButtons
      .fire({
        title:
          t("services.contact_for_free_trial"),
        showCancelButton: true,
        confirmButtonText: t("ship.yes"),
        cancelButtonText: t("ship.no"),
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          window.open("https://m.me/F0orweb", "_blank", "noopener,noreferrer");
        } else result.dismiss === Swal.DismissReason.cancel;
      });
  };

  const truncateName = (name, maxLength = 20) => {
    return name.length > maxLength
      ? name.substring(0, maxLength) + "..."
      : name;
  };

  const handleDelete = async (data) => {
    Swal.fire({
      title: t("ship.confirm_delete"),
      text: t("ship.delete_order_prompt"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "rgb(141, 93, 167)",
      cancelButtonColor: "#e87778",
      confirmButtonText: t("ship.yes"),
      cancelButtonText: t("ship.no"),
    }).then(async (result) => {
      if (result.isConfirmed) {
        const deletedProduct = await workerAPI.deleteProduct(data.id);
        syncAccountIfProvided(deletedProduct);
        dispatch(updateProduct(deletedProduct));
      }
    });
  };

  const handleUpdate = async (rowData) => {
    setData(rowData);
    setLgShow(true);
  };

  const handleEcomanager = (products) => {
    const urlEcomanager = `${store.Secomanager}products`;
    axios
      .post(
        urlEcomanager,
        {
          title: products?.name,
          sku: products?.sku,
          price: parseInt(products?.price),
          is_active: true,
          open_stock: true,
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${store.ecomanager}`,
          },
        }
      )
      .then((response) => {
        console.log("نجح الاستجابة:", response.data);
      })
      .catch((error) => {
        console.error("حدث خطأ:", error);
      });
  };

  const paidBodyTemplate = (rowData) => {
    const color = rowData.show === "1" ? "#12b669" : "#474747";

    return (
      <>
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip>{t("insightads.published")} </Tooltip>}
        >
          <div className="relative inline-block w-11 h-5">
            <input
              aria-label={t("insightads.status")}
              id={`switch-${rowData.id}`}
              type="checkbox"
              checked={rowData.show === "1"}
              onChange={
                !!account?.store
                  ? (e) => {
                    changepaid(rowData, e.target.checked ? "1" : "0");
                  }
                  : () => {
                    message();
                  }
              }
              className="peer appearance-none w-11 h-5 bg-[#232323] border border-slate-300 rounded-full checked:bg-[#12b669] checked:border-slate-800 cursor-pointer transition-colors duration-300"
            />
            <label
              htmlFor={`switch-${rowData.id}`}
              className="absolute top-0 left-0 w-5 h-5 bg-white rounded-full border border-slate-300 shadow transition-transform duration-300 peer-checked:translate-x-6 peer-checked:border-slate-800 cursor-pointer"
            ></label>
          </div>
        </OverlayTrigger>
      </>
    );
  };

  const isOtpExpired = async () => {
    const tokenOtp = localStorage.getItem("otpToken");
    if (!tokenOtp) return true;

    try {
      // الحصول على بيانات المفتاح السري من Firestore
      const secretRef = doc(db, "secretKeys", account?.user);
      const secretDoc = await getDoc(secretRef);

      if (!secretDoc.exists()) {
        return true; // إذا لم يكن هناك مستند، فالـ OTP منتهي الصلاحية
      }

      const secretData = secretDoc.data();
      const storedToken = secretData.token;
      const lastUsed = secretData.lastUsed;

      // التحقق من أن الـ token متطابق
      if (storedToken !== tokenOtp) {
        return true;
      }

      // التحقق من أن الـ token لم يتجاوز 30 دقيقة (30 * 60 * 1000 = 1800000 مللي ثانية)
      const currentTime = Date.now();
      const timeDifference = currentTime - lastUsed;
      const thirtyMinutesInMs = 30 * 60 * 1000;

      if (timeDifference > thirtyMinutesInMs) {
        // إزالة الـ token من localStorage لأنه منتهي الصلاحية
        localStorage.removeItem("otpToken");
        return true;
      }

      return false; // الـ token صالح
    } catch (error) {
      console.error("Error checking OTP expiration:", error);
      return true; // في حالة الخطأ، نعتبر الـ token منتهي الصلاحية
    }
  };

  const CombinedTemplate = ({ rowData, confirmers, ...props }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedUsers, setSelectedUsers] = useState(new Set());
    const buttonImage = "/logo-min 2.png";
    const togglePopup = () => {
      setIsOpen(!isOpen);
    };

    const closePopup = () => {
      setIsOpen(false);
    };

    const toggleProductStatus = async (checked) => {
      const newStatus = checked;
      setIsAll(newStatus);

      const updatedProduct = await workerAPI.updateProduct(rowData.id, {
        isAll: newStatus,
      });

      syncAccountIfProvided(updatedProduct);
      dispatch(updateProduct(updatedProduct));
    };

    const setUptoDelivery = async (checked) => {
      const newStatus1 = checked;
      setIsAll(newStatus1);

      const updatedProduct = await workerAPI.updateProduct(rowData.id, {
        upToDelivery: newStatus1,
      });

      syncAccountIfProvided(updatedProduct);
      dispatch(updateProduct(updatedProduct));
    };

    const setEditOrders = async (checked) => {
      const newStatus2 = checked;
      setIsAll(newStatus2);
      const updatedProduct = await workerAPI.updateProduct(rowData.id, {
        editToOrders: newStatus2,
      });
      syncAccountIfProvided(updatedProduct);
      dispatch(updateProduct(updatedProduct));
    };

    const handleAddProduct = async () => {
      if (selectedUsers.size === 0) {
        Swal.fire({
          title: t("error"),
          text: t("Products.Table.confirmers.selectUserError"),
          icon: "error",
          confirmButtonText: t("common.ok"),
        });
        return;
      }

      try {
        const newProductData = {
          active: true,
          beginDate: new Date(),
          endDate: null,
          shopName: account?.name,
          shopUser: account?.user,
          sku: [`${rowData.sku}`],
          storeImage: account?.image,
        };
        //* do Api for rules
        const q = query(
          collection(db, "confirmers"),
          where("user", "in", Array.from(selectedUsers))
        );

        const querySnapshot = await getDocs(q);

        if (querySnapshot.empty) {
          Swal.fire({
            title: t("warning"),
            text: t("ui.userNotFound"),
            icon: "warning",
            confirmButtonText: t("common.ok"),
          });
          return;
        }

        const updates = querySnapshot.docs.map(async (doc) => {
          const data = doc.data();
          const existingProductIndex = data.products.findIndex(
            (product) => product.shopUser === account?.user
          );

          if (existingProductIndex !== -1) {
            const existingProduct = data.products[existingProductIndex];
            const skuIndex = existingProduct.sku.indexOf(rowData.sku);

            if (skuIndex !== -1) {
              // Remove the SKU if it exists
              existingProduct.sku.splice(skuIndex, 1);
              await updateDoc(doc.ref, { products: data.products });
            } else {
              // If 'all' is found, replace it with the new SKU
              const allIndex = existingProduct.sku.indexOf("all");
              if (allIndex !== -1) {
                existingProduct.sku[allIndex] = rowData.sku;
              } else {
                existingProduct.sku.push(rowData.sku);
              }
              await updateDoc(doc.ref, { products: data.products });
            }
          } else {
            // Add the new product
            await updateDoc(doc.ref, {
              products: arrayUnion(newProductData),
            });
          }
        });

        await Promise.all(updates);

        const result = await Swal.fire({
          title: t("Products.Table.confirmers.success"),
          icon: "success",
          confirmButtonText: t("common.ok"),
        });

        if (result.isConfirmed) {
          console.log("تم اختيار التاريخ:", result.value);
        }

        if (result.isConfirmed) {
          closePopup();
        }
      } catch (error) {
        console.error("Error adding/removing product: ", error);
        Swal.fire({
          title: t("error"),
          text:
            error.message || t("ui.productAssignmentError"),
          icon: "error",
          confirmButtonText: t("common.ok"),
        });
      }
    };

    const handleDelete = async (userId) => {
      // تأكيد المستخدم قبل الحذف
      const result = await Swal.fire({
        title: t("ship.confirm_delete"),
        text: t("ui.deleteProductConfirm"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: t("cashBack.swal.deleteConfirm.confirm"),
        cancelButtonText: t("annule"),
      });

      if (!result.isConfirmed) {
        // إذا لم يؤكد المستخدم، لا تنفذ عملية الحذف
        return;
      }

      try {
        const q = query(
          collection(db, "confirmers"),
          where("addedBy", "==", account?.user)
        );

        const querySnapshot = await getDocs(q);

        if (querySnapshot.empty) {
          Swal.fire({
            title: t("warning"),
            text: t("ui.userNotFound"),
            icon: "warning",
            confirmButtonText: t("common.ok"),
          });
          return;
        }

        const updates = querySnapshot.docs.map(async (doc) => {
          const data = doc.data();
          const productIndex = data.products.findIndex(
            (product) => product.shopUser === account?.user
          );

          if (productIndex !== -1) {
            let updatedProducts = [...data.products];
            const product = updatedProducts[productIndex];
            const skuIndex = product.sku.indexOf(rowData.sku);

            if (skuIndex !== -1) {
              product.sku.splice(skuIndex, 1);

              if (product.sku.length === 0) {
                // Replace with 'all' if SKU list is empty
                product.sku.push("all");
              }
            }

            // Update the product in Firestore
            await updateDoc(doc.ref, { products: updatedProducts });
          }
        });

        await Promise.all(updates);

        Swal.fire({
          title: t("Products.Table.confirmers.success"),
          text: t("ui.productRemoved"),
          icon: "success",
          confirmButtonText: t("common.ok"),
        });
      } catch (error) {
        console.error("Error deleting product: ", error);
        Swal.fire({
          title: t("error"),
          text: error.message || t("ui.deleteProductError"),
          icon: "error",
          confirmButtonText: t("common.ok"),
        });
      }
    };

    const handleCheckboxChange = (user, isChecked) => {
      const updatedSelectedUsers = new Set(selectedUsers);
      if (isChecked) {
        updatedSelectedUsers.add(user);
      } else {
        updatedSelectedUsers.delete(user);
      }
      setSelectedUsers(updatedSelectedUsers);
    };

    return (
      <div className="relative">
        <button
          className="flex items-center justify-center py-2.5 border rounded-lg hover:bg-[#faf1ff] dark:!border-[#3c3a3d] dark:!bg-[#181919] transition-colors active:bg-[#faf1ff] bot mx-auto"
          onClick={togglePopup}
        >
          <img src={buttonImage} style={{ width: "20px" }} alt={t("ui.buttonIcon")} />
        </button>

        <Modal
          visible={isOpen}
          onCancel={closePopup}
          footer={null}
          width="25%"
          destroyOnClose
          wrapClassName={isDark ? "dark-modal" : ""}
        >
          <div className="flex items-center justify-between p-4 border-b border-gray-200 dark:border-[#3c3a3d] dark:bg-[#181919]">
            <h2 className="text-lg font-medium text-gray-800 dark:text-gray-200">
              {t("ui.productConfirmers")}
            </h2>
          </div>

          <div className="dark:bg-[#181919]">
            <div className="max-w-5xl mx-auto px-4 mt-2 md:px-8 dark:bg-[#181919]">
              <div className="flex justify-between p-4 rounded-md bg-blue-50 border border-blue-300 dark:!bg-[#1e1e1e] dark:border-[#3c3a3d]">
                <div className="flex gap-3">
                  <div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6 text-blue-500 dark:text-blue-400"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth={2}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                  </div>
                  <div className="self-center">
                    <span className="text-blue-600 dark:text-blue-400 font-medium">
                      {t("ui.noticeLabel")}
                    </span>
                    <div className="text-blue-600 dark:text-blue-400">
                      <p className="mt-2 sm:text-sm">
                        {t("ui.confirmerCapacityHelp")}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <ul className="grid gap-y-2 gap-x-6 flex-wrap mt-3 overflow-y-auto">
              {confirmers.map((confirmer, idx) => {
                const isSkuInConfirmer = confirmer.products?.some(
                  (product) =>
                    Array.isArray(product.sku) &&
                    product.sku.some((sku) => sku === rowData.sku)
                );
                const isChecked = isSkuInConfirmer;

                return (
                  confirmer.deleted !== true &&
                  isChecked && (
                    <div
                      className="ant-col ant-col-24 hp-border-radius-lx hp-border-1 border border-gray-200 dark:border-[#3c3a3d] dark:bg-[#1e1e1e]"
                      style={{
                        paddingLeft: "6px",
                        paddingRight: "6px",
                        position: "relative",
                      }}
                      key={idx}
                    >
                      <img
                        src="https://cdn-icons-png.flaticon.com/128/9427/9427108.png"
                        style={{ zIndex: 10, width: "22px" }}
                        onClick={() => handleDelete(confirmer.user)}
                        className="absolute top-0 left-0 cursor-pointer"
                      />

                      <div
                        className="ant-row ant-row-space-between ant-row-middle"
                        style={{ rowGap: "0px" }}
                      >
                        <div className="ant-col ant-col-24 hp-mb-sm-16 ant-col-sm-12">
                          <div
                            className="ant-row ant-row-no-wrap ant-row-middle"
                            style={{ rowGap: "0px" }}
                          >
                            <Checkbox
                              id={`confirmer-${idx}`}
                              type="checkbox"
                              className="checkbox-item peer hidden"
                              onChange={(e) =>
                                handleCheckboxChange(
                                  confirmer.user,
                                  e.target.checked
                                )
                              }
                              checked
                              disabled
                            />

                            <div className="ant-col">
                              <div
                                className="hp-border-radius-md hp-cursor-pointer hp-border-1 hp-mr-16 m-2 rounded-full border-gray-300 dark:border-[#3c3a3d]"
                                style={{
                                  maxHeight: "64px",
                                  maxWidth: "64px",
                                }}
                              >
                                <div className="hp-border-radius-in hp-overflow-hidden hp-m-4 hp-d-flex rounded-full">
                                  <img
                                    src={
                                      confirmer.image ||
                                      "https://randomuser.me/api/portraits/women/79.jpg"
                                    }
                                    alt={t("workersManagement.table.user")}
                                    style={{ height: "100%" }}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="ant-col">
                              <span className="hp-d-block hp-p3-body hp-font-weight-700 text-gray-800 dark:text-gray-200">
                                {confirmer.name}
                              </span>
                              <span
                                className="hp-d-block hp-p1-body text-gray-700 dark:text-gray-400"
                                style={{ fontSize: "11px" }}
                              >
                                {confirmer.phone}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div
                          className="ant-col ant-col-12 hp-text-sm-left hp-text-right ant-col-sm-6"
                          style={{ minHeight: "50px" }}
                        >
                          <span className="hp-d-block hp-p3-body hp-font-weight-400 hp-slashed-zero text-gray-800 dark:text-gray-200">
                            {t("ui.confirmedLabel")}{" "}
                            <span className="fs-2-5 ">
                              {" "}
                              {confirmer.pricing?.confirmPrice}{" "}
                              {localizedCurrency}
                            </span>
                          </span>
                          <span className="hp-d-block hp-p1-body hp-mt-4 hp-slashed-zero text-gray-700 dark:text-gray-400">
                            {t("ui.cancelledLabel")}{" "}
                            <span className="fs-2-4 ">
                              {" "}
                              {confirmer.pricing?.cancelPrice}{" "}
                              {localizedCurrency}
                            </span>
                          </span>
                        </div>
                        <div className="ant-col">
                          <a href={`tel:${confirmer.phone}`}>
                            <img
                              src="https://cdn-icons-png.flaticon.com/128/16620/16620482.png"
                              alt={t("workersManagement.table.user")}
                              style={{
                                maxWidth: "34px",
                                cursor: "pointer",
                              }}
                            />
                          </a>
                        </div>
                      </div>
                    </div>
                  )
                );
              })}
            </ul>

            <ul className="grid gap-y-2 gap-x-6 flex-wrap mt-3">
              {confirmers.map((confirmer, idx) => {
                const isSkuInConfirmer = confirmer.products?.some(
                  (product) =>
                    Array.isArray(product.sku) &&
                    product.sku.some((sku) => sku === rowData.sku)
                );
                const isChecked = isSkuInConfirmer;

                return (
                  confirmer.deleted !== true &&
                  !isChecked && (
                    <div
                      className="ant-col ant-col-24 hp-border-radius-lx hp-border-1 border border-gray-200 dark:border-[#3c3a3d] dark:bg-[#1e1e1e]"
                      style={{ paddingLeft: "6px", paddingRight: "6px" }}
                      key={idx}
                    >
                      <div
                        className="ant-row ant-row-space-between ant-row-middle"
                        style={{ rowGap: "0px" }}
                      >
                        <div className="ant-col ant-col-24 hp-mb-sm-16 ant-col-sm-12">
                          <div
                            className="ant-row ant-row-no-wrap ant-row-middle"
                            style={{ rowGap: "0px" }}
                          >
                            <Checkbox
                              id={`confirmer-${idx}`}
                              type="checkbox"
                              className="checkbox-item peer hidden"
                              onChange={(e) =>
                                handleCheckboxChange(
                                  confirmer.user,
                                  e.target.checked
                                )
                              }
                            />

                            <div className="ant-col">
                              <div
                                className="hp-border-radius-md hp-cursor-pointer hp-border-1 hp-mr-16 m-2 rounded-full border-gray-300 dark:border-[#3c3a3d]"
                                style={{
                                  maxHeight: "64px",
                                  maxWidth: "64px",
                                }}
                              >
                                <div className="hp-border-radius-in hp-overflow-hidden hp-m-4 hp-d-flex rounded-full">
                                  <img
                                    src={
                                      confirmer.image ||
                                      "https://randomuser.me/api/portraits/women/79.jpg"
                                    }
                                    alt={t("workersManagement.table.user")}
                                    style={{ height: "100%" }}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="ant-col">
                              <span className="hp-d-block hp-p3-body hp-font-weight-700 text-gray-800 dark:text-gray-200">
                                {confirmer.name}
                              </span>
                              <span
                                className="hp-d-block hp-p1-body text-gray-700 dark:text-gray-400"
                                style={{ fontSize: "11px" }}
                              >
                                {confirmer.phone}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div
                          className="ant-col ant-col-12 hp-text-sm-left hp-text-right ant-col-sm-6"
                          style={{ minHeight: "50px" }}
                        >
                          <span className="hp-d-block hp-p3-body hp-font-weight-400 hp-slashed-zero text-gray-800 dark:text-gray-200">
                            {t("ui.confirmedLabel")}{" "}
                            <span className="fs-2-5">
                              {confirmer.pricing?.confirmPrice}{" "}
                              {localizedCurrency}
                            </span>
                          </span>
                          <span className="hp-d-block hp-p1-body hp-mt-4 hp-slashed-zero text-gray-700 dark:text-gray-400">
                            {t("ui.cancelledLabel")}{" "}
                            <span className="fs-2-4">
                              {confirmer.pricing?.cancelPrice}{" "}
                              {localizedCurrency}
                            </span>
                          </span>
                        </div>
                        <div className="ant-col">
                          <a href={`tel:${confirmer.phone}`}>
                            <img
                              src="https://cdn-icons-png.flaticon.com/128/16620/16620482.png"
                              alt={t("workersManagement.table.user")}
                              style={{
                                maxWidth: "34px",
                                cursor: "pointer",
                              }}
                            />
                          </a>
                        </div>
                      </div>
                    </div>
                  )
                );
              })}
            </ul>
            <div className="p-4 border-t border-gray-200 dark:border-[#3c3a3d] mt-4 dark:bg-[#181919]">
              <div className="ant-col ant-col-24">
                <h3 className="text-gray-800 dark:text-gray-200">{t("servicePageActivation.foorchat.settingchat.title")}</h3>
                <div className="hp-profile-notifications hp-mt-24">
                  {/* Switch 1 */}
                  <Row
                    className="ant-row-space-between ant-row-middle"
                    style={{ rowGap: 0 }}
                  >
                    <Col
                      className="hp-caption text-gray-800 dark:text-gray-300"
                      span={24}
                      xs={15}
                    >
                      {t("ui.showToConfirmers")}
                    </Col>
                    <Col>
                      <Switch
                        style={{ width: "45px" }}
                        checked={rowData.isAll}
                        onChange={(checked) => {
                          Swal.fire({
                            title: t("cashBack.swal.deleteConfirm.title"),
                            text: t("Products.Table.confirmers.changeStatusText"),
                            icon: "warning",
                            showCancelButton: true,
                            confirmButtonColor: "#3085d6",
                            cancelButtonColor: "#d33",
                            confirmButtonText: t("ui.yesChange"),
                          }).then((result) => {
                            if (result.isConfirmed) {
                              toggleProductStatus(checked);
                            }
                          });
                        }}
                        checkedChildren=""
                        unCheckedChildren=""
                        className="hp-mt-sm-8 hp-ml-sm-0 hp-ml-8"
                      />
                    </Col>
                  </Row>

                  {/* Switch 2 */}
                  <Row
                    className="ant-row-space-between ant-row-middle hp-mt-18"
                    style={{ rowGap: 0 }}
                  >
                    <Col
                      className="hp-caption text-gray-800 dark:text-gray-300"
                      span={24}
                      xs={15}
                    >
                      {t("ui.confirmerEditHelp")}
                    </Col>
                    <Col>
                      <Switch
                        style={{ width: "45px" }}
                        checked={rowData.editToOrders}
                        onChange={(checked) => {
                          Swal.fire({
                            title: t("cashBack.swal.deleteConfirm.title"),
                            text: t("Products.Table.confirmers.changeStatusText"),
                            icon: "warning",
                            showCancelButton: true,
                            confirmButtonColor: "#3085d6",
                            cancelButtonColor: "#d33",
                            confirmButtonText: t("ui.yesChange"),
                          }).then((result) => {
                            if (result.isConfirmed) {
                              setEditOrders(checked);
                            }
                          });
                        }}
                        checkedChildren=""
                        unCheckedChildren=""
                        className="hp-mt-sm-8 hp-ml-sm-0 hp-ml-8"
                      />
                    </Col>
                  </Row>

                  {/* Switch 3 */}
                  <Row
                    className="ant-row-space-between ant-row-middle hp-mt-18"
                    style={{ rowGap: 0 }}
                  >
                    <Col
                      className="hp-caption text-gray-800 dark:text-gray-300"
                      span={24}
                      xs={15}
                    >
                      {t("ui.autoSendHelp")}
                    </Col>
                    <Col>
                      <Switch
                        style={{ width: "45px" }}
                        checked={rowData.upToDelivery}
                        onChange={(checked) => {
                          Swal.fire({
                            title: t("cashBack.swal.deleteConfirm.title"),
                            text: t("Products.Table.confirmers.changeStatusText"),
                            icon: "warning",
                            showCancelButton: true,
                            confirmButtonColor: "#3085d6",
                            cancelButtonColor: "#d33",
                            confirmButtonText: t("ui.yesChange"),
                          }).then((result) => {
                            if (result.isConfirmed) {
                              setUptoDelivery(checked);
                            }
                          });
                        }}
                        checkedChildren=""
                        unCheckedChildren=""
                        className="hp-mt-sm-8 hp-ml-sm-0 hp-ml-8"
                      />
                    </Col>
                  </Row>
                </div>
              </div>

              {/* Bouton Confirmer */}
              <div className="p-4 border-t border-gray-200 dark:border-[#3c3a3d] mt-4">
                <button
                  className="w-full px-4 py-2 text-white bg-[#9b59bf] hover:bg-[#8a4eaa] rounded-md focus:outline-none focus:ring focus:ring-indigo-200 focus:ring-opacity-50 sm:text-sm"
                  onClick={handleAddProduct}
                >
                  {t("ui.confirmAction")}
                </button>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  };

  const ProductButton = (product) => {
    return (
      <button
        onClick={() => handleEcomanager(product)}
        className="flex items-center justify-center py-2.5 border rounded-lg hover:bg-[#faf1ff] dark:!bg-[#181919] dark:!border-[#3c3a3d] transition-colors active:bg-[#faf1ff] bot mx-auto"
      >
        <img src="/ecomanger.png" style={{ width: "20px" }} alt={t("ui.buttonIcon")} />
      </button>
    );
  };

  const imageBodyTemplate = (rowData) => {
    return (
      <div className="relative w-16 h-16">
        {rowData.image ? (
          <div className="absolute w-14 h-14 rounded-lg overflow-hidden bg-[#faf1ff] shadow-sm">
            <img
              src={rowData.image}
              onError={(e) => (e.target.src = "/product-foorweb.png")}
              alt={rowData.name || t("settings.product")}
              className="w-full h-full object-cover"
            />
          </div>
        ) : (
          <div className="absolute w-14 h-14 rounded-lg overflow-hidden bg-[#faf1ff] shadow-sm flex items-center justify-center text-[#9e68ba]">
            <Tag size={24} />
          </div>
        )}
      </div>
    );
  };

  const priceproduct = (rowData) => {
    return (
      <div className="flex items-center justify-start gap-2 text-gray-700">
        <span className="text-end font-medium" style={{ color: "#6e4881" }}>
          {rowData.price} {localizedCurrency}
        </span>
      </div>
    );
  };

  const visitspriproduct = (rowData) => {
    return (
      <div className="flex items-center justify-start gap-2 text-gray-700">
        <span className="text-end">{rowData.visits ? rowData.visits : 0}</span>
      </div>
    );
  };

  const viewpage = (rowData) => {
    return (
      <button
        className="flex items-center justify-center mx-auto"
        onClick={() => {
          if (!account?.store) {
            message.error(t("Products.Table.noStore"));
            return;
          }

          if (account?.productMode === "digital") {
            const storeName = account?.store?.split(".")[0];
            const newDomain = `${storeName}.foorweb.online`;
            const finalUrl = `${newDomain}/products/${rowData.url}`;
            window.open(finalUrl, "_blank", "noopener,noreferrer");
          } else {
            const baseUrl = account.store.replace(/\/+$/, "");
            const storeName = baseUrl.split("://")[1].split(".")[0];
            const fullUrl = `${baseUrl}/${storeName}/products/${rowData.url}`;

            window.open(fullUrl, "_blank", "noopener,noreferrer");
          }
        }}
      >
        <img
          style={{ width: "32px", height: "32px" }}
          src="/vision.png"
          className="rounded-full"
          alt={t("cashBack.page.countText")}
        />
      </button>
    );
  };

  const actionTemplate = (rowData) => {
    return (
      <div className="relative">
        <button
          onClick={(e) => {
            e.stopPropagation();
            setOpenDropdownId(
              openDropdownId === rowData.id ? null : rowData.id
            );
          }}
          className="p-2 rounded-full hover:bg-purple-100 transition-colors"
        >
          <MoreVertical
            size={18}
            className="text-[#9e68ba] dark:text-[#b57ed8]"
          />
        </button>
        <div
          className={`absolute mt-1 bg-white border border-[#fbf4ff] shadow-lg rounded-lg z-[200] w-[130px] ${openDropdownId === rowData.id ? "block" : "hidden"
            }`}
          style={{ pointerEvents: "auto" }}
        >
          <ul className="py-1">
            <li
              onClick={async (e) => {
                setOpenDropdownId(null);
                e.stopPropagation();
                if (!!account?.store) {
                  if (
                    account?.productMode != "digital" ||
                    !account?.twoFAActivated
                  )
                    return handleUpdate(rowData);
                  const expired = await isOtpExpired();
                  if (expired) {
                    setPendingRowData(rowData);
                    setShowOtpModal(true);
                  } else {
                    handleUpdate(rowData);
                  }
                } else {
                  message();
                }

                setOpenDropdownId(null);
              }}
              className="px-4 py-2 hover:bg-[#fcf6ff] dark:hover:bg-[#2a2a2a] cursor-pointer flex items-center gap-2 transition-colors text-gray-800 dark:text-gray-200"
            >
              <Edit size={14} className="text-green-600" />
              <span>{t("Products.Table.Actions.edit")}</span>
            </li>

            <li
              onClick={(e) => {
                setOpenDropdownId(null);
                e.stopPropagation();
                if (!!account?.store) {
                  window.open(
                    `${account?.store}Landingpage/${rowData.url}`,
                    "_blank",
                    "noopener,noreferrer"
                  );
                } else {
                  message();
                }
                setOpenDropdownId(null);
              }}
              className="px-4 py-2 hover:bg-[#fcf6ff] dark:hover:bg-[#2a2a2a] cursor-pointer flex items-center gap-2 transition-colors text-gray-800 dark:text-gray-200"
            >
              <Eye size={14} className="text-blue-600" />
              <span>{t("Products.Table.Actions.viewLanding")}</span>
            </li>
            {canDeleteProducts && (
              <li
                onClick={(e) => {
                  setOpenDropdownId(null);
                  e.stopPropagation();
                  if (!!account?.store) {
                    handleDelete(rowData);
                  } else {
                    message();
                  }
                  setOpenDropdownId(null);
                }}
                className="px-4 py-2 hover:bg-[#fcf6ff] dark:hover:bg-[#2a2a2a] cursor-pointer flex items-center gap-2 transition-colors text-gray-800 dark:text-gray-200"
              >
                <Trash size={14} className="text-red-600" />
                <span>{t("Products.Table.Actions.delete")}</span>
              </li>
            )}
          </ul>
        </div>
      </div>
    );
  };

  // Render the new styled table
  return (
    <div className="bg-purple-50 dark:!bg-[#141414] col-span-1 md:col-span-2 rounded-xl shadow-md w-full border border-[#fbf4ff] dark:!border-[#3c3a3d]">
      <div className="p-6 flex flex-col h-full dark:!bg-[#181919]">
        <h5 className="font-bold text-lg text-gray-800 dark:text-gray-100 m-0 dark:!bg-[#181919] flex items-center">
          {t("Products.Table.title")}
        </h5>

        <div className="w-full overflow-visible bg-white dark:!bg-[#181919] rounded-xl mt-4 shadow-sm">
          <div className="overflow-x-auto">
            <style>{darkModeStyles}</style>
            <table
              className={`w-full ${direction === "rtl" ? "text-right" : "text-left"
                }`}
            >
              <thead>
                <tr className="bg-purple-100 dark:!bg-[#1e1e1e] ">
                  <th className="p-4 font-medium text-[#9e68ba]">
                    {t("Products.Table.headers.product")}
                  </th>
                  <th className="p-4 font-medium text-[#9e68ba]">
                    {t("Products.Table.headers.name")}
                  </th>
                  <th className="p-4 font-medium text-[#9e68ba]">
                    {t("Products.Table.headers.sku")}
                  </th>
                  <th className="p-4 font-medium text-[#9e68ba]">
                    {t("Products.Table.headers.preview")}
                  </th>
                  <th className="p-4 font-medium text-[#9e68ba]">
                    {t("Products.Table.headers.quantity")}
                  </th>
                  <th className="p-4 font-medium text-[#9e68ba]">
                    {t("Products.Table.headers.price")}
                  </th>
                  <th className="p-4 font-medium text-[#9e68ba]">
                    {t("Products.Table.headers.visits")}
                  </th>
                  {canEditProducts && (
                    <th className="p-4 font-medium text-[#9e68ba] text-center">
                      {t("Products.Table.headers.status")}
                    </th>
                  )}
                  <th className="w-8 p-4"></th>
                  {canEditProducts && (
                    <th className="p-4 font-medium text-[#9e68ba]">
                      {t("Products.Table.headers.actions")}
                    </th>
                  )}
                  <th className="w-8 p-4"></th>
                </tr>
              </thead>

              <tbody>
                {products.length > 0 ? (
                  (!!filter
                    ? products.filter(
                      (product) =>
                        product.name
                          .toLowerCase()
                          .includes(filter.toLowerCase()) ||
                        product.sku
                          .toLowerCase()
                          .includes(filter.toLowerCase())
                    )
                    : _DATA.currentData()
                  ).map((product, index) => (
                    <React.Fragment key={product.id || index}>
                      <tr
                        className={`border-b border-gray-200 dark:border-[#3c3a3d] hover:bg-[#fcf6ff] dark:hover:bg-[#2a2a2a] transition-colors ${index % 2 === 0
                            ? "bg-white dark:bg-[#181919]"
                            : "bg-gray-50 dark:bg-[#1e1e1e]"
                          }`}
                      >
                        <td className="p-4">{imageBodyTemplate(product)}</td>
                        <td
                          className="p-4 font-medium text-gray-800 dark:text-gray-200"
                          style={{ maxWidth: "250px" }}
                        >
                          {truncateName(product.name, 25)}
                        </td>
                        <td className="p-4 text-gray-700 dark:text-gray-300">
                          {product.sku}
                        </td>
                        <td className="p-4">{viewpage(product)}</td>
                        <td className="p-4 text-gray-700 dark:text-gray-300">
                          {product.qty || 0}
                        </td>
                        <td className="p-4">{priceproduct(product)}</td>
                        <td className="p-4">{visitspriproduct(product)}</td>

                        {/* Send To Team */}
                        {/* {account?.productMode !== "digital" && (
                          <td className="p-4">
                            <CombinedTemplate
                              rowData={product}
                              confirmers={confirmers}
                              account={account}
                              store={store}
                              setData={setData}
                              setLgShow={setLgShow}
                            />
                          </td>
                        )} */}

                        {/* Ecomanager */}
                        {store?.ecomangerActive &&
                          account?.productMode !== "digital" && (
                            <td className="p-4">{ProductButton(product)}</td>
                          )}

                        {/* Published Status */}
                        {canEditProducts && (
                          <td className="p-4 text-center">
                            {paidBodyTemplate(product)}
                          </td>
                        )}
                        {canEditProducts && (
                          <td className="p-4">{actionTemplate(product)}</td>
                        )}
                        <td className="p-4">
                          <button
                            onClick={() => toggleRow(product.id)}
                            className="p-2 rounded-full hover:bg-[#faf1ff] dark:hover:bg-[#2a2a2a] transition-colors"
                          >
                            {expandedRows[product.id] ? (
                              <ChevronUp
                                size={18}
                                className="text-[#9e68ba] dark:text-[#b57ed8]"
                              />
                            ) : (
                              <ChevronDown
                                size={18}
                                className="text-[#9e68ba] dark:text-[#b57ed8]"
                              />
                            )}
                          </button>
                        </td>
                      </tr>

                      {expandedRows[product.id] && (
                        <tr className="bg-[#fcf6ff] dark:bg-[#1a1a1a]">
                          <td
                            colSpan={store?.ecomangerActive ? 12 : 11}
                            className="p-0"
                          >
                            <div className="h-fit overflow-y-auto">
                              <div className="p-6 rounded-xl bg-white dark:!bg-[#181919] border border-[#fbf4ff] dark:!border-[#3c3a3d] shadow-md m-4">
                                <h4
                                  className={`text-lg font-medium dark:!bg-[#181919] mb-4 text-[#9e68ba] dark:text-[#b57ed8] border-b border-[#fbf4ff] dark:border-[#3c3a3d] pb-2 sticky top-0 bg-white z-10 ${direction === "rtl"
                                      ? "text-right"
                                      : "text-left"
                                    }`}
                                >
                                  {t("Products.Table.expand.title")}
                                </h4>
                                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 dark:!border-[#3c3a3d]">
                                  {[
                                    {
                                      title: "Products.Table.expand.info.title",
                                      content: (
                                        <>
                                          <span className="font-medium text-gray-800 dark:text-gray-200">
                                            {t(
                                              "Products.Table.expand.info.name"
                                            )}
                                          </span>
                                          <span className="text-gray-700 dark:text-gray-300">
                                            {product.name}
                                          </span>
                                          <br />
                                          <span className="font-medium text-gray-800 dark:text-gray-200">
                                            {t(
                                              "Products.Table.expand.info.sku"
                                            )}
                                          </span>
                                          <span className="text-gray-700 dark:text-gray-300">
                                            {product.sku}
                                          </span>
                                          <br />
                                          <span className="font-medium text-gray-800 dark:text-gray-200">
                                            {t(
                                              "Products.Table.expand.info.quantity"
                                            )}
                                          </span>
                                          <span className="text-gray-700 dark:text-gray-300">
                                            {product.qty || 0}
                                          </span>
                                          <br />
                                          <span className="font-medium text-gray-800 dark:text-gray-200">
                                            {t(
                                              "Products.Table.expand.info.price"
                                            )}
                                          </span>
                                          <span className="text-gray-700 dark:text-gray-300">
                                            {product.price} {localizedCurrency}
                                          </span>
                                        </>
                                      ),
                                    },
                                    {
                                      title:
                                        "Products.Table.expand.category.title",
                                      content: (
                                        <>
                                          <span className="font-medium text-gray-800 dark:text-gray-200">
                                            {t(
                                              "Products.Table.expand.category.category"
                                            )}
                                          </span>
                                          <span className="text-gray-700 dark:text-gray-300">
                                            {product.category_id ||
                                              t(
                                                "Products.Table.expand.default.noCategory"
                                              )}
                                          </span>
                                          <br />
                                          <span className="font-medium text-gray-800 dark:text-gray-200">
                                            {t(
                                              "Products.Table.expand.category.rating"
                                            )}
                                          </span>
                                          <span className="text-gray-700 dark:text-gray-300">
                                            {product.review || 0}{" "}
                                            {t(
                                              "Products.Table.expand.default.stars"
                                            )}
                                          </span>
                                          <br />
                                          <span className="font-medium text-gray-800 dark:text-gray-200">
                                            {t(
                                              "Products.Table.expand.category.visits"
                                            )}
                                          </span>
                                          <span className="text-gray-700 dark:text-gray-300">
                                            {product.visits || 0}
                                          </span>
                                          <br />
                                          <span className="font-medium text-gray-800 dark:text-gray-200">
                                            {t(
                                              "Products.Table.expand.category.shipping"
                                            )}
                                          </span>
                                          <span className="text-gray-700 dark:text-gray-300">
                                            {t(
                                              "Products.Table.expand.default.available"
                                            )}
                                          </span>
                                        </>
                                      ),
                                    },
                                    {
                                      title:
                                        "Products.Table.expand.notes.title",
                                      content: (
                                        <span className="text-gray-700 dark:text-gray-300">
                                          {product.comment ||
                                            t(
                                              "Products.Table.expand.default.noNotes"
                                            )}
                                        </span>
                                      ),
                                    },
                                  ].map((section, i) => (
                                    <div
                                      key={i}
                                      className="bg-[#fcf6ff] dark:bg-[#1e1e1e] p-4 rounded-lg border border-[#fbf4ff] dark:!border-[#3c3a3d]"
                                    >
                                      <h5
                                        className={`text-sm font-medium text-[#9e68ba] dark:text-[#b57ed8] mb-2 ${direction === "rtl"
                                            ? "text-right"
                                            : "text-left"
                                          }`}
                                      >
                                        {t(section.title)}
                                      </h5>
                                      <div
                                        className={`text-gray-700 dark:text-gray-300 ${direction === "rtl"
                                            ? "text-right"
                                            : "text-left"
                                          }`}
                                      >
                                        {section.content}
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan={store?.ecomangerActive ? 12 : 11}
                      className="p-8 text-center text-gray-500 dark:text-gray-400"
                    >
                      {t("Products.Table.empty")}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        {showOtpModal && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white p-6 rounded-md w-96 shadow-lg">
              <h2 className="text-lg font-semibold mb-4 text-center text-gray-700">
                {t("Products.Table.otp.title")}
              </h2>
              <input
                type="text"
                value={verificationCode}
                onChange={(e) => setVerificationCode(e.target.value)}
                maxLength={6}
                className="w-full border border-gray-300 rounded-md px-4 py-2 mb-4 text-center text-lg tracking-widest"
                placeholder="______"
              />
              <div className="flex justify-end gap-2">
                <button
                  onClick={() => setShowOtpModal(false)}
                  className="px-4 py-2 bg-gray-300 text-gray-700 rounded-md"
                >
                  {t("Products.Table.otp.cancel")}
                </button>
                <button
                  onClick={handleVerifyCode}
                  className="px-4 py-2 bg-[#7e5395] text-white rounded-md"
                >
                  {t("Products.Table.otp.verify")}
                </button>
              </div>
            </div>
          </div>
        )}

        <div
          className={`flex justify-center py-3 bg-white dark:!bg-[#181919] mt-4 rounded-xl direction-rtl `}
        >
          <Stack spacing={2} dir={direction}>
            <Pagination
              count={count}
              size="large"
              page={page}
              variant="outlined"
              shape="rounded"
              onChange={handleChange}
              color="secondary"
              sx={{
                backgroundColor: isDark ? "#181919" : "#ffffff",
                borderRadius: 2,
                p: 2,
                "& .MuiPaginationItem-root": {
                  color: isDark ? "#e1cfff" : "#000000",
                  borderColor: isDark ? "#a065c0" : "#ccc",
                },
                "& .MuiPaginationItem-root.Mui-selected": {
                  backgroundColor: isDark ? "#9b59bf" : "#9b59bf",
                  color: "#fff",
                },
                "& .MuiPaginationItem-root:hover": {
                  backgroundColor: isDark ? "#7c3aad" : "#f0f0f0",
                },
              }}
            />
          </Stack>
        </div>
      </div>
    </div>
  );
};

export default DataTableTemplatingDemo;
